"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('startup-layout', {
    ref: "layout",
    staticClass: "kiwi-welcome-simple",
    scopedSlots: _vm._u([_vm.startupOptions.altComponent ? {
      key: "connection",
      fn: function fn() {
        return [_c(_vm.startupOptions.altComponent, {
          tag: "component",
          on: {
            "close": _vm.onAltClose
          }
        })];
      },
      proxy: true
    } : {
      key: "connection",
      fn: function fn() {
        return [_vm.resumePending ? _c('div', {
          staticClass: "kiwi-welcome-resume-pending",
          attrs: {
            "role": "status"
          }
        }, [_c('i', {
          staticClass: "fa fa-spin fa-spinner",
          attrs: {
            "aria-hidden": "true"
          }
        }), _c('span', [_vm._v("Ripristino della sessione in corso…")]), _c('button', {
          staticClass: "u-button kiwi-welcome-resume-cancel",
          attrs: {
            "type": "button"
          },
          on: {
            "click": _vm.cancelStartupResume
          }
        }, [_vm._v(" Annulla ")])]) : _c('form', {
          staticClass: "u-form u-form--big kiwi-welcome-simple-form",
          on: {
            "submit": function submit($event) {
              $event.preventDefault();
              return _vm.formSubmit.apply(null, arguments);
            }
          }
        }, [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.showBanner && _vm.bannerHasAd,
            expression: "showBanner && bannerHasAd"
          }],
          staticClass: "kiwi-welcome-banner-container"
        }, [_c('div', {
          ref: "welcomeAdSlot",
          staticClass: "kiwi-adnet-slot",
          attrs: {
            "id": "ad-9f73a40c-0d64-45ad-93a3-b95d41b554f3"
          }
        }), _c('button', {
          staticClass: "kiwi-welcome-banner-close",
          attrs: {
            "type": "button",
            "title": "Chiudi la pubblicità"
          },
          on: {
            "click": _vm.closeWelcomeBanner
          }
        }, [_vm._v("×")])]), _c('h2', {
          domProps: {
            "innerHTML": _vm._s(_vm.greetingText)
          }
        }), _vm.resumeError ? _c('div', {
          staticClass: "kiwi-welcome-simple-error"
        }, [_c('span', [_vm._v(_vm._s(_vm.resumeError))])]) : _vm._e(), _vm.network && (_vm.connectErrors.length > 0 || _vm.network.state_error) ? _c('div', {
          staticClass: "kiwi-welcome-simple-error"
        }, [_vm.connectErrors.length > 0 ? _vm._l(_vm.connectErrors, function (err) {
          return _c('span', {
            key: err
          }, [_vm._v(_vm._s(err))]);
        }) : [_c('span', [_vm._v(_vm._s(_vm.$t('network_noconnect')))]), _c('span', [_vm._v(_vm._s(_vm.readableStateError(_vm.network.state_error)))])]], 2) : _vm._e(), _c('input-text', {
          directives: [{
            name: "focus",
            rawName: "v-focus",
            value: !_vm.isIframe && (!_vm.nick || !_vm.show_password_box),
            expression: "!isIframe && (!nick || !show_password_box)"
          }],
          class: {
            'kiwi-welcome-invalid-nick': !_vm.isNickValid
          },
          attrs: {
            "label": _vm.$t('nick'),
            "type": "text"
          },
          model: {
            value: _vm.nick,
            callback: function callback($$v) {
              _vm.nick = $$v;
            },
            expression: "nick"
          }
        }), _vm.nick && !_vm.isNickValid ? _c('div', {
          staticClass: "kiwi-welcome-nick-warning"
        }, [_vm._v(" " + _vm._s(_vm.$t('nick_digits_only_at_end')) + " ")]) : _vm._e(), _vm.showPass && _vm.toggablePass ? _c('div', {
          staticClass: "kiwi-welcome-simple-input-container"
        }, [_c('label', {
          staticClass: "kiwi-welcome-simple-have-password"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.show_password_box,
            expression: "show_password_box"
          }],
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": Array.isArray(_vm.show_password_box) ? _vm._i(_vm.show_password_box, null) > -1 : _vm.show_password_box
          },
          on: {
            "change": function change($event) {
              var $$a = _vm.show_password_box,
                $$el = $event.target,
                $$c = $$el.checked ? true : false;
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.show_password_box = (0, _concat.default)($$a).call($$a, [$$v]));
                } else {
                  var _context;
                  $$i > -1 && (_vm.show_password_box = (0, _concat.default)(_context = (0, _slice.default)($$a).call($$a, 0, $$i)).call(_context, (0, _slice.default)($$a).call($$a, $$i + 1)));
                }
              } else {
                _vm.show_password_box = $$c;
              }
            }
          }
        }), _c('span', [_vm._v(" 🔐 " + _vm._s(_vm.$t('password_have')) + " ")])])]) : _vm._e(), _vm.showPass && (_vm.show_password_box || !_vm.toggablePass) ? _c('div', {
          staticClass: "kiwi-welcome-simple-input-container"
        }, [_c('input-text', {
          directives: [{
            name: "focus",
            rawName: "v-focus",
            value: !_vm.isIframe && _vm.nick || _vm.show_password_box,
            expression: "(!isIframe && nick) || show_password_box"
          }],
          attrs: {
            "show-plain-text": true,
            "label": _vm.$t('password'),
            "type": "password"
          },
          model: {
            value: _vm.password,
            callback: function callback($$v) {
              _vm.password = $$v;
            },
            expression: "password"
          }
        })], 1) : _vm._e(), _vm.showChannel ? _c('div', {
          staticClass: "kiwi-welcome-simple-input-container"
        }, [_c('input-text', {
          attrs: {
            "label": _vm.$t('channel')
          },
          model: {
            value: _vm.channel,
            callback: function callback($$v) {
              _vm.channel = $$v;
            },
            expression: "channel"
          }
        })], 1) : _vm._e(), _c('div', {
          staticClass: "kiwi-welcome-simple-input-container kiwi-welcome-feature-highlight"
        }, [_c('label', {
          staticClass: "kiwi-welcome-simple-have-password"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.showMoreInfo,
            expression: "showMoreInfo"
          }],
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": Array.isArray(_vm.showMoreInfo) ? _vm._i(_vm.showMoreInfo, null) > -1 : _vm.showMoreInfo
          },
          on: {
            "change": function change($event) {
              var $$a = _vm.showMoreInfo,
                $$el = $event.target,
                $$c = $$el.checked ? true : false;
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.showMoreInfo = (0, _concat.default)($$a).call($$a, [$$v]));
                } else {
                  var _context2;
                  $$i > -1 && (_vm.showMoreInfo = (0, _concat.default)(_context2 = (0, _slice.default)($$a).call($$a, 0, $$i)).call(_context2, (0, _slice.default)($$a).call($$a, $$i + 1)));
                }
              } else {
                _vm.showMoreInfo = $$c;
              }
            }
          }
        }), _c('span', [_c('strong', [_vm._v("♀️ Mostra sesso ed età degli utenti")])])])]), _vm.showMoreInfo ? [_c('div', {
          staticClass: "kiwi-welcome-simple-input-container"
        }, [_vm.showExtraMessage ? _c('p', {
          staticClass: "kiwi-welcome-intro"
        }, [_vm._v(" Per visualizzare genere ed età degli altri utenti, inserisci le tue informazioni. ")]) : _vm._e(), _c('label', {
          staticClass: "kiwi-welcome-simple-label",
          attrs: {
            "for": "gender_select"
          }
        }, [_vm._v("Genere")]), _c('select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.gender,
            expression: "gender"
          }],
          staticClass: "u-input",
          attrs: {
            "id": "gender_select"
          },
          on: {
            "change": function change($event) {
              var _context3;
              var $$selectedVal = (0, _map.default)(_context3 = (0, _filter.default)(Array.prototype).call($event.target.options, function (o) {
                return o.selected;
              })).call(_context3, function (o) {
                var val = "_value" in o ? o._value : o.value;
                return val;
              });
              _vm.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
            }
          }
        }, [_c('option', {
          attrs: {
            "value": "U"
          }
        }, [_vm._v("Scegli il tuo genere...")]), _c('option', {
          attrs: {
            "value": "M"
          }
        }, [_vm._v("Uomo")]), _c('option', {
          attrs: {
            "value": "F"
          }
        }, [_vm._v("Donna")]), _c('option', {
          attrs: {
            "value": "N"
          }
        }, [_vm._v("Non binario")])])]), _c('div', {
          staticClass: "kiwi-welcome-simple-input-container"
        }, [_c('label', {
          staticClass: "kiwi-welcome-simple-label",
          attrs: {
            "for": "age_input"
          }
        }, [_vm._v("Età")]), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model.number",
            value: _vm.age,
            expression: "age",
            modifiers: {
              "number": true
            }
          }],
          staticClass: "u-input",
          attrs: {
            "id": "age_input",
            "type": "number",
            "min": "13",
            "max": "99",
            "value": "18",
            "placeholder": "Inserisci la tua età"
          },
          domProps: {
            "value": _vm.age
          },
          on: {
            "input": function input($event) {
              if ($event.target.composing) return;
              _vm.age = _vm._n($event.target.value);
            },
            "blur": function blur($event) {
              return _vm.$forceUpdate();
            }
          }
        })]), _c('div', {
          staticClass: "kiwi-welcome-simple-input-container"
        }, [_c('label', {
          staticClass: "kiwi-welcome-simple-label",
          attrs: {
            "for": "provincia_select"
          }
        }, [_vm._v("Provincia")]), _c('select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.provincia,
            expression: "provincia"
          }],
          staticClass: "u-input",
          attrs: {
            "id": "provincia_select"
          },
          on: {
            "change": function change($event) {
              var _context4;
              var $$selectedVal = (0, _map.default)(_context4 = (0, _filter.default)(Array.prototype).call($event.target.options, function (o) {
                return o.selected;
              })).call(_context4, function (o) {
                var val = "_value" in o ? o._value : o.value;
                return val;
              });
              _vm.provincia = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
            }
          }
        }, [_c('option', {
          attrs: {
            "value": "UU"
          }
        }, [_vm._v("Scegli la tua provincia...")]), _vm._l(_vm.provinceItaliane, function (prov) {
          return _c('option', {
            key: prov.value,
            domProps: {
              "value": prov.value
            }
          }, [_vm._v(" " + _vm._s(prov.text) + " (" + _vm._s(prov.value) + ") ")]);
        })], 2)])] : _vm._e(), _vm.termsContent ? _c('div', {
          staticClass: "kiwi-welcome-simple-terms"
        }, [_c('div', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.termsAccepted,
            expression: "termsAccepted"
          }],
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": Array.isArray(_vm.termsAccepted) ? _vm._i(_vm.termsAccepted, null) > -1 : _vm.termsAccepted
          },
          on: {
            "change": function change($event) {
              var $$a = _vm.termsAccepted,
                $$el = $event.target,
                $$c = $$el.checked ? true : false;
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.termsAccepted = (0, _concat.default)($$a).call($$a, [$$v]));
                } else {
                  var _context5;
                  $$i > -1 && (_vm.termsAccepted = (0, _concat.default)(_context5 = (0, _slice.default)($$a).call($$a, 0, $$i)).call(_context5, (0, _slice.default)($$a).call($$a, $$i + 1)));
                }
              } else {
                _vm.termsAccepted = $$c;
              }
            }
          }
        })]), _c('div', {
          staticClass: "kiwi-welcome-simple-terms-content",
          domProps: {
            "innerHTML": _vm._s(_vm.termsContent)
          }
        })]) : _vm._e(), _c('captcha', {
          attrs: {
            "network": _vm.network
          }
        }), !_vm.network || _vm.network.state === 'disconnected' ? _c('button', {
          staticClass: "u-button u-button-primary u-submit kiwi-welcome-simple-start",
          attrs: {
            "disabled": !_vm.readyToStart,
            "type": "submit"
          },
          domProps: {
            "innerHTML": _vm._s(_vm.buttonText)
          }
        }) : _c('button', {
          staticClass: "u-button u-button-primary u-submit kiwi-welcome-simple-start",
          attrs: {
            "type": "button",
            "disabled": ""
          }
        }, [_c('i', {
          staticClass: "fa fa-spin fa-spinner",
          attrs: {
            "aria-hidden": "true"
          }
        })]), _c('div', {
          domProps: {
            "innerHTML": _vm._s(_vm.footerText)
          }
        })], 2)];
      },
      proxy: true
    }], null, true)
  });
};
exports.render = render;
var staticRenderFns = [];
exports.staticRenderFns = staticRenderFns;